export namespace ConfigConstants {
    /**
     * Constant route paths
     */
    export const routeUrlDashboard = 'main/dashboard';
    export const routeUrlConfirmation = 'main/confirmation';
    export const routeUrlDetails = 'main/details';
    export const routeUrlTimesheet = 'main/timesheet';
    export const routeUrlLocationTracker = 'main/location-tracker';
    export const routeUrlForms = 'main/forms';
    export const routeUrlForms2 = 'main/forms2';
    export const routeUrlDocBox = 'main/docbox';
    export const routeUrlWidgets = 'main/widgets';
    export const routeUrlNotifications = 'main/notifications';
    export const routeUrlSmartlocker = 'main/smartlocker';
    export const routeUrlSpector = 'main/pace-spector';

    export const debounceTimeMs = 300;
    export const formatXSDTimeDuration = '[PT]HH[H]mm[M]ss[S]';
    export const formatDateNoTimezone = 'YYYY-MM-DD[T]HH:mm:ss';
    export const formatDateWithoutSplitter = 'YYYYMMDD';
    export const formatGatewayIdempotentHeaderDate = 'dd, D MMM YYYY H:mm:ss ZZ';
    export const formatSAPDate = '[/Date(]x[)/]';
    export const formatDay = 'dd';
    export const formatDayUs = 'ddd';
    export const formatPatternTimeGeneric = 'HH:mm';
    export const formatPatternTimeIn12Hours = 'hh:mm A';
    export const formatPatternTimeWithSecondsGeneric = 'HH:mm:ss';
    export const formatPatternTimeIn12HoursWithSeconds = 'hh:mm:ss A';
    export const formatNumberPatternTime = 'HHmm';
    export const formatPatternDateGeneric = 'DD.MM.YYYY';
    export const formatPatternDateTimeWithSeparator = 'DD/MM/YYYY | HH:mm';
    export const formatPatternShortDateGeneric = 'DD.MM.';
    export const formatPatternDateTimeGeneric = 'DD.MM.YYYY HH:mm';
    export const formatPatternDateTimePCH = 'YYYY:MM:DD HH:mm:ss';
    export const formatPatternShortDateTimeGeneric = 'DD.MM. HH:mm';
    export const formatPatternDateUS = 'MM/DD/YYYY';
    export const formatPatternMonthYear = 'MM/YYYY';
    export const formatPatternDateCosima = 'DD-MMM-YYYY';
    export const formatPatternDateFDA = 'YYYY-MM-DD';
    export const formatPatternDatePaceFormsEvo = 'DD-MMM-YYYY';
    export const formatPatternDateIndia = 'DD/MM/YYYY';
    export const formatPatternShortDateIndia = 'DD/MM/';
    export const formatPatternShortDateUS = 'MM/DD/';
    export const formatPatternShortDatePaceFormsEvo = 'DD-MMM';
    export const formatPatternDateTimeUS = 'MM/DD/YYYY hh:mm A';
    export const formatPatternShortDateTimeUS = 'MM/DD/ hh:mm A';
    export const formatPatternDateTimeIndia = 'DD.MM.YYYY hh:mm A';
    export const formatPatternShortDateTimeIndia = 'DD.MM. h:mm A';
    export const escalationTimeoutAlertTimingInHours = 4;
    export const defaultEtaAlertTimerLimit = 30;
    export const createNotificationDefaultAppTime = 2200;
    export const startTimeFlexibleHours = 3;
    export const confirmationComplaintsInitialSelection = 2;
    export const defaultEtaLimitMinutes = 180;
    export const confirmationComplaintsQuestion1 = 'Q01';
    export const confirmationComplaintsQuestion2 = 'Q02';
    export const confirmationComplaintsQuestion3 = 'Q03';
    export const confirmationComplaintsQuestion4 = 'Q04';
    export const confirmationComplaintsQuestion5 = 'Q05';
    export const formatPatternDateTimeSmartlocker = 'MM/DD/YYYY h:mm:ss A';
    export const defaultSmartlockerActiveToDays = 30;
    // CommCategory is communication category. It is 'S' for Service Report and 'Q' for Quotation
    export const confirmationServiceReportCommCategory = 'S';
    export const quotationCommCategory = 'Q';
    export const personalQuoteType = '5';
    export const customerDirectOrderType = '6';

    export const MaterialConsumedInstDateOld = 'InstDateOld';
    export const MaterialConsumedInstDateNew = 'InstDateNew';
    export const MaterialConsumedCounterOld = 'CounterOld';
    export const MaterialConsumedCounterNew = 'CounterNew';

    export const optionYes = 'Yes';
    export const optionValueYes = '1';
    export const optionNo = 'No';
    export const optionValueNo = '0';
    export const optionNA = 'N/A';
    export const optionUnknown = 'Unknown';
    export const optionValueNA = '2';
    export const optionYesShort = 'Y';
    export const optionNoShort = 'N';

    export const confirmationMissingProtocolCodeType = 'A';
    export const confirmationMissingProtocolCodeGroup = 'SRINF';

    export const realNumberRegex =
        '^(?:-(?:[1-9](?:\\d{0,2}(?:,\\d{3})+|\\d*))|(?:0|(?:[1-9](?:\\d{0,2}(?:,\\d{3})+|\\d*))))(?:.\\d+|)$';
    export const emailValidationRegex =
        '^([a-zA-Z0-9\\+_\\-]+)(\\.[a-zA-Z0-9\\+_\\-]+)*@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z]{2,6}$';

    export enum CrmMissingProtocolReasonCodes {
        OTHR = 'OTHR',
        NRCK = 'NRCK',
        MDEV = 'MDEV',
        ABSE = 'ABSE',
        MCSE = 'MCSE',
        FAIN = 'FAIN',
    }

    export enum DimStatus {
        LastStatus = 'dimLastStatus',
        LastTwoStatus = 'dimLastTwoStatus',
        Default = '',
    }

    // notificaton types
    export enum NotificationTypes {
        Unknown = 'UNKNOWN',
        Training = 'MA',
        Installation = 'MI',
        Maintenance = 'MM',
        Service = 'MS',
        Special = 'MT',
        Update = 'MU',
        Workshop = 'MW',
    }

    export enum USER_STATUS {
        PHI = 'PHI',
        PSI = 'PSI',
        PPI = 'PPI',
        CYS = 'CYS',
        NESC = 'NESC',
        REMT = 'REMT',
    }

    export const FDACertifiedOption0 = '0';
    export const FDACertifiedOptionValue0 = '0';

    export const FDACertifiedOption1 = '1';
    export const FDACertifiedOptionValue1 = '1';

    export const FDACertifiedOption2 = '2';
    export const FDACertifiedOptionValue2 = '2';

    export const FDACertifiedOption3 = '3';
    export const FDACertifiedOptionValue3 = '3';

    export const FDACertifiedOption4 = '4';
    export const FDACertifiedOptionValue4 = '4';

    export const FDACertifiedOptionNA = 'N.A';
    export const FDACertifiedOptionValueNA = 'NA';

    /** Name of the FDA 2579 form's `ArrayModel` holding its 15 component-information rows. */
    export const FDA2579_COMPONENT_LIST_NAME = 'ComponentInfo';

    /** Equipment `Division` value for CT equipment. */
    export const EQUIPMENT_DIVISION_CT = '03';

    export enum MATERIAL_BILLABLE_CHANGEABLE {
        Yes = 'Y',
        No = 'N',
    }

    export enum ElementType {
        // eslint-disable-next-line id-denylist
        String = 'S',
        // eslint-disable-next-line id-denylist
        Number = 'N',
        Date = 'D',
        Unknown = '',
    }

    export enum ApplicationIdentifier {
        ProductIdentifier = '240',
        SerialNumber = '21',
        LotNumber = '10',
        Default = '',
    }

    // Names/IDs of value helper entities
    export const valueHelperIDCreateMatOrderPriority = 'MaterialOrderPriority';
    export const valueHelperIDEquipmentBKInfo = 'EquipmentBKInfo';
    export const valueHelperIDCommercialInfoDefaultCode = 'CommercialInfoDefaultCode';
    export const valueHelperIDEquipmentErrorCode = 'EquipmentErrorCode';
    export const valueHelperIDEquipmentReason = 'EquipmentReason';
    export const valueHelperIDEquipmentStatusAfterFix = 'EquipmentStatusAfterFix';
    export const valueHelperIDEquipmentStatusInArrival = 'EquipmentStatusInArrival';
    export const valueHelperIDCentriCareStatusAfterFix = 'CentriCareStatusAfterFix';
    export const valueHelperIDCentriCareStatInArrival = 'CentriCareStatInArrival';
    export const valueHelperIDExpenseType = 'ExpenseType';
    export const valueHelperIDFeedbackIsSatisfied = 'FeedbackIsSatisfied';
    export const valueHelperIDFollowUpHasCall = 'FollowUpHasCall';
    export const valueHelperIDFollowUpJobType = 'FollowUpJobType';
    export const valueHelperIDFollowUpUMRCode = 'FollowUpUMRCode';
    export const valueHelperIDFollowDispatchTime = 'FollowDispatchTime';
    export const valueHelperIDTexasEPECodes = 'TexasEPECodes';
    export const valueHelperIDMaterialAdditionalType = 'MaterialAdditionalType';
    export const valueHelperIDMaterialError = 'MaterialError';
    export const valueHelperIDMaterialMK = 'MaterialMK';
    export const valueHelperIDMaterialQuoteType = 'MaterialQuoteType';
    export const valueHelperIDMaterialPhiDataCode = 'MaterialDataMedium';
    export const valueHelperIDTimeRecordingTaskTypeInfo = 'TimeRecordingTaskTypeInfo';
    export const valueHelperIDTimesheetTaskTypeInfo = 'TimesheetTaskTypeInfo';
    export const valueHelperIDTimesheetGapTypeInfo = 'WorkCode';
    export const valueHelperIDTimesheetActivityType = 'ActivityType';
    export const valueHelperIDTimeRecordingBillable = 'BillableTime';
    export const valueHelperIDMeansOfTransportation = 'MeansOfTransport';
    export const valueHelperIDTravelDestination = 'Destination';
    export const valueHelperIDPdaConfig = 'PDAConfig';
    export const valueHelperIDNotificationEffectCode = 'NotificationEffectCode';
    export const valueHelperIDNotificationType = 'NotificationType';
    export const valueHelperIDCseSaleType = 'CseSaleType';
    export const valueHelperIDBillable = 'Billable';
    export const valueHelperIDMaterialErrorTubeJ = 'MaterialErrorTubeJ';
    export const valueHelperIDMaterialErrorTubeI = 'MaterialErrorTubeI';
    export const valueHelperIDMaterialBug = 'MaterialBug';
    export const valueHelperIDReturnType = 'ReturnType';
    export const valueHelperIDMaterialBusinessForTubes = 'MaterialBusinessForTubes';
    export const valueHelperIDMaterialReturnCause = 'MaterialReturnCause';
    export const valueHelperIDQuoteType = 'QuoteType';
    export const valueHelperIDComplaintQuestions = 'QuestionID';
    export const valueHelperIDQualityControlQuestions = 'QualityControlQuestions';
    export const valueHelperIDTimeRecordingCategory = 'TimeRecordingCategory';
    export const valueHelperIDTimeRecordingDelivery = 'TimeRecordingDelivery';
    export const valueHelperIDTimeRecordingActivityType = 'TimeRecordingActivityType';
    export const valueHelperIDTimeRecordingBookingCategory = 'TimeRecordingBookingCategory';
    export const valueHelperIDAttendeeTitles = 'AttendeeTitles';
    export const valueHelperIDModalityValues = 'ModalityValues';
    export const valueHelperIDFollowupReason = 'FollowupReason';
    export const valueHelperIDSRSVPNConnection = 'SRSVPNConnection';
    export const valueHelperIDAddMaterialType = 'AddMaterialType';
    export const valueHelperIDTravelOfficeStart = 'TravelOfficeStart';
    export const valueHelperIDDangerousGoodWarning = 'DangerousGoodWarning';
    export const valueHelperIDFurtherLinks = 'FurtherLinks';
    export const valueHelperIDTextClause = 'TextClause';
    export const valueHelperIDMaterialConsumedLabel = 'MaterialConsumedLabel';
    export const valueHelperIDUploadToDocbox = 'UploadToDocbox';
    export const valueHelperIDMissingProtocols = 'MissingProtocolValues';
    export const valueHelperIDStatesOfUSA = 'StatesOfUSA';
    export const valueHelperIDFDAFormIntendedUses = 'FDAFormIntendedUses';
    export const valueHelperXraySystems = 'XraySystems';
    export const valueHelperIDFDAFormCertifiedComponent = 'FDAFormCertifiedComponent';
    export const valueHelperIDFDAFormOtherCertifiedComponent = 'FDAFormOtherCertifiedComp';
    export const valueHelperIDFDAFormComponentInfo = 'FDAFormComponentInfo';

    // separators for fileNames
    export const unixFileNameSeparator = '|';
    export const windowsFileNameSeparator = '-';

    // end of work
    export const eowFlexibleHours = 1;

    // material order
    export const messageVersion = '0001';

    /**
     * Sets a timeout (in ms) for the whole app-start process. After this delay the authentication and all subsequent
     * actions are started. This allows the developer to open and attach the Safari Debugger bevor any action starts.
     */
    export const timeToOpenSafariDebuggerTimeout = 0;

    /**
     * User Master Configuration Constants
     */
    export const scannable = 'Scannable';

    export const sapTrue = 'X'; // the character used by the backend to signal that a boolean property is set to true
    export const sapFalse = ''; // the character used by the backend to signal that a boolean property is set to false
    export const sapTrueBinaryValue = 1; // the character used by the backend for FDA 2579 form to signal that a boolean property is set to true then send 1
    export const sapFalseBinaryValue = 0; // the character used by the backend for FDA 2579 form to signal that a boolean property is set to true then send 0

    export const validationBackupPattern = {
        // regular expressions to validate input fields by DataType
        // eslint-disable-next-line id-denylist
        String: '[^]*',
        Integer: '\\d*',
        Decimal: '\\d+(\\.\\d+)?',
        Time: '[012]?\\d{1}:\\d{2}',
    };

    export const internalInfoTextLineRegex = {
        date: '[0-9]{2}[-.|/]{1}[0-9]{2}[-.|/]{1}[0-9]{4}',
        gid: '\\b[a-zA-Z0-9-]{8}\\b',
        headerInfo: '[0-9]{2}[-.|\\/]{1}[0-9]{2}[-.|\\/]{1}[0-9]{4}.[by]*.{2}.[a-zA-Z0-9]{8}',
    };
    export const validationKeypress = {
        // regular expressions that can be used to check single key presses for validity for this DataType
        // eslint-disable-next-line id-denylist
        String: '.', // Strings can be anything
        Integer: '[0-9-]', // Integer consists only of numbers
        Decimal: '[0-9.,-]', // Decimal can contain numbers and a dot/comma
        Currency: '[0-9.,]',
    };
    export const validationType = {
        // html input types by DataType
        // eslint-disable-next-line id-denylist
        String: 'text',
        Integer: 'number',
        Decimal: 'number',
        Time: 'text',
        Date: 'date',
        Checkbox: 'checkbox',
        RadioBtn: 'radio',
        Currency: 'text',
    };
    export const validationParser = {
        // which function to use to convert a string to the corresponding DataType
        // eslint-disable-next-line id-denylist
        String: (e: string): string => e.toString(), // convert to string
        Integer: parseInt,
        Decimal: parseFloat,
        Time: (e: string): string => e,
        Date: (e: string): string => e,
        Checkbox: (e: string): string => e,
        RadioBtn: (e: string): string => e,
        Currency: (e: string): string => e,
    };

    // Ticket to collect emoji regex issues is https://evorait.atlassian.net/browse/SHP-6197
    export const defaultEmojiRegex =
        '\u00a9|\u00ae|[\u2000-\u2012]|[\u2015-\u2017]|[\u2020-\u2025]|[\u2027-\u2099]|[\u2101-\u3300]|(\ud83c[\ud000-\udfff])|(\ud83d[\ud000-\udfff])|(\ud83e[\ud000-\udfff])';

    export const defaultAllowedMimeTypes = ['image/tiff', 'image/jpg', 'image/jpeg', 'application/pdf'];

    export const configKeyMaterialErrorCodeCountMax = 'MaterialErrorCodeCountMax';
    export const configKeyMaterialLiBatteryStandAlone = 'MaterialLiBatteryStandAlone';
    export const configKeyMaterialLiBatteryInDevice = 'MaterialLiBatteryInDevice';
    export const configKeyMaterialOrderPriorityForSplit = 'MaterialOrderPriorityForSplit';
    export const configKeyUserFrontId = 'UserFrontId';
    export const configKeyMaxInterimsCount = 'MaxInterimsCount';
    export const configKeyCseEmailFax = 'CseEmailFax';
    export const configKeyShowRefreshXMLButton = 'ShowRefreshXMLButton';
    export const configKeyDisplayCustomerContact = 'DisplayCustomerContact';
    export const configKeyShowLanguageSelectionDropdown = 'ShowLanguageSelectionDropdown';
    export const configKeyEscalationEmail = 'EscalationEmail';
    export const configKeyInstructionsUrl = 'InstructionsService';
    export const configKeyShowDocumentationLink = 'ShowDocumentationLink';
    export const configKeyExpenseCurrency = 'ExpenseCurrency';
    export const configKeyShowInfoToCCC = 'ShowInfoToCCC';
    export const configKeySwitzerland = 'CH';
    export const configKeyGermany = 'DE';
    export const configKeyNetherlands = 'NL';
    export const configKeyIndia = 'IN';
    export const configKeyJapan = 'JP';
    export const configKeyAustralia = 'AU';
    export const configKeyNewZealand = 'NZ';
    export const configKeyKorea = 'KR';
    export const configKeyChina = 'CN';
    export const configKeyAustria = 'AT';
    export const configKeyFrance = 'FR';
    export const configKeyFinland = 'FL';
    export const configKeyCzechia = 'CZ';
    export const configKeyBulgaria = 'BG';
    export const configKeyTurkey = 'TR';
    export const configKeySpain = 'ES';
    export const configKeyLegalHandoverSafetyInfoText = 'LegalHandoverSafetyInfoText';
    export const configKeyLegalHandoverSafetyInfoCode = 'LegalHandoverSafetyInfoCode';
    export const configKeyLegalHandoverUserDocText = 'LegalHandoverUserDocText';
    export const configKeyLegalHandoverUserDocCode = 'LegalHandoverUserDocCode';
    export const configKeyLegalIEC62353Text = 'Legal_IEC62353_Text';
    export const configKeyLegalIEC62353Code = 'Legal_IEC62353_Code';
    export const configKeyLegalPCResistanceText = 'Legal_PCResistance_Text';
    export const configKeyLegalPCResistanceCode = 'Legal_PCResistance_Code';
    export const configKeyLegalDeviceLeakageText = 'Legal_DeviceLeakage_Text';
    export const configKeyLegalDeviceLeakageCode = 'Legal_DeviceLeakage_Code';
    export const configKeyLegalXRayText = 'Legal_XRay_Text';
    export const configKeyLegalXRayCode = 'Legal_XRay_Code';
    export const configKeyLegalDosageCode = 'Legal_Dosage_Code';
    export const configKeyLegalDosageText = 'Legal_Dosage_Text';
    export const configKeyLegalRadioProtectionText = 'Legal_Radioprotection_Text';
    export const configKeyLegalRadioProtectionCode = 'Legal_Radioprotection_Code';
    export const configKeyLegalInstallationCheckText = 'Legal_Installationcheck_Text';
    export const configKeyLegalInstallationCheckCode = 'Legal_Installationcheck_Code';
    export const configKeyLegalStatusCheckText = 'Legal_Statuscheck_Text';
    export const configKeyLegalStatusCheckCode = 'Legal_Statuscheck_Code';
    export const configKeyLegalConsistencyCheckText = 'Legal_Consistencycheck_Text';
    export const configKeyLegalConsistencyCheckCode = 'Legal_Consistencycheck_Code';
    export const configKeyLegalPartiallyCheckedText = 'Legal_PartiallyChecked_Text';
    export const configKeyLegalPartiallyCheckedCode = 'Legal_PartiallyChecked_Code';
    export const configKeyLegalAcceptanceTestCode = 'Legal_AcceptanceTest_Code';
    export const configKeyLegalPartialAcceptanceTestCode = 'Legal_PartialAcceptanceTest_Code';
    export const configKeyLegalHealthCheckCode = 'Legal_HealthCheck_Code';
    export const configKeyLegalConsistencyTestCode = 'Legal_ConsistencyTest_Code';
    export const configKeyLegalVDE701702Text = 'Legal_VDE701702_Text';
    export const configKeyLegalVDE701702Code = 'Legal_VDE701702_Code';
    export const configKeyLegalVDEPCResistanceText = 'Legal_VDE_PCResistance_Text';
    export const configKeyLegalVDEPCResistanceCode = 'Legal_VDE_PCResistance_Code';
    export const configKeyLegalVDEDeviceLeakageText = 'Legal_VDE_DeviceLeakage_Text';
    export const configKeyLegalVDEDeviceLeakageCode = 'Legal_VDE_DeviceLeakage_Code';
    export const configKeyLegalVDEInsulationResistanceText = 'Legal_VDE_InsulationResista_Text';
    export const configKeyLegalVDEInsulationResistanceCode = 'Legal_VDE_InsulationResista_Code';
    export const configKeyLegalNEN1010Text = 'Legal_NEN1010_Text';
    export const configKeyLegalNEN1010Code = 'Legal_NEN1010_Code';
    export const configKeyLegalK3RoomText = 'Legal_K3Room_Text';
    export const configKeyLegalK3RoomCode = 'Legal_K3Room_Code';
    export const configKeyLegalMeasurementPerformedText = 'Legal_MeasurementPerformed_Text';
    export const configKeyLegalMeasurementPerformedCode = 'Legal_MeasurementPerformed_Code';
    export const configKeyLegalInsulationResistanceText = 'Legal_InsulationResistance_Text';
    export const configKeyLegalInsulationResistanceCode = 'Legal_InsulationResistance_Code';
    export const configKeyLegalMeasurementNotNeededText = 'Legal_MeasurementNotNeeded_Text';
    export const configKeyLegalMeasurementNotNeededCode = 'Legal_MeasurementNotNeeded_Code';
    export const configKeyLegal3551NotificationTypes = 'Legal3551NotificationTypes';
    export const configKeyLegal3551DetachPowerCordText = 'Legal3551DetachPowerCordText';
    export const configKeyLegal3551PermanentConnectedText = 'Legal3551PermanentConnectedText';
    export const configKeyLegal3551NonDetachPowerCordText = 'Legal3551NonDetachPowerCordText';
    export const configKeyLegal3551DetachPowerCordCode = 'Legal3551DetachPowerCordCode';
    export const configKeyLegal3551PermanentConnectedCode = 'Legal3551PermanentConnectedCode';
    export const configKeyLegal3551NonDetachPowerCordCode = 'Legal3551NonDetachPowerCordCode';
    export const configKeyLegalVerificationNotifTypes = 'LegalVerificationNotifTypes';
    export const configKeyLegalVerifiedSecurityDeviceText = 'LegalVerifiedSecurityDeviceText';
    export const configKeyLegalVerifiedSecurityDeviceCode = 'LegalVerifiedSecurityDeviceCode';
    export const configKeyLegalResumptionUserValidText = 'LegalResumptionUserValidText';
    export const configKeyLegalResumptionUserValidCode = 'LegalResumptionUserValidCode';
    export const configKeyEowSowBreakHours = 'EowSowBreakHours';
    export const configKeyEowFlexibleHours = 'EowFlexibleHours';
    export const configKeyCseCountry = 'CseCountry';
    export const configKeyEtaLimitMinutes = 'ETALimitMinutes';
    export const configKeyEtaLimitAA = 'ETAP';
    export const configKeyEtaAlertTimerLimit = 'EtaAlertTimerLimit';
    export const configKeyDisplayEtaAlert = 'DisplayEtaAlert';
    export const configKeyTravLimitAA = 'TRAP';
    export const configKeyOsrLimitAA = 'OSRP';
    export const configKeyPhoneFixIndicatorAA = 'PhoneFixVis';
    export const configKeyMaterialHistoryLimit = 'MaterialHistoryDays';
    export const configKeyPredefinedEmailDomainName = 'PredefinedEmailDomain';
    export const configKeyReportTextLineLength = 'ReportTextLineLength';
    export const configKeyReportTextMaxLines = 'ReportTextMaxLines';
    export const configKeyNotificationHistoryDays = 'NotificationHistoryDays';
    export const configKeyMaterialOrderNonSplitUnits = 'MaterialOrderNonSplitUnits';
    export const configKeyEnableMatOrderCheckOnlineOnly = 'EnableMatOrderCheckOnlineOnly';

    export const configKeyComplaintNotifTypes = 'Complaint_Notif_Types';
    export const configKeyFollowupDefaultTimeP58 = 'FollowUpDefaultTime';
    export const configKeyFollowupDefaultAdditionalTime = 'FollowupDefaultAdditionalTime';
    export const configKeyFollowUpDefaultDays = 'FollowUpDefaultDays';
    export const configKeyFollowupMinAdditionalTime = 'FollowupMinAdditionalTime';
    export const configKeyFollowupAdditionalTimeStep = 'FollowupAdditionalTimeStep';
    export const configKeyShowEquipment = 'ShowEquipment';
    export const configKeyShowMaterialConsumption = 'ShowMaterialConsumption';
    export const configKeyShowMeasurementTools = 'ShowMeasurementTools';
    export const configKeyShowParticipantList = 'ShowParticipantList';
    export const configKeyShowFollowup = 'ShowFollowup';
    export const configKeyShowFollowupLongText = 'ShowFollowupLongText';
    export const configKeyShowFollowupAdditionalInfo = 'ShowFollowupAdditionalInfo';
    export const configKeyShowMeasuringPoints = 'ShowMeasuringPoints';
    export const configKeyAppsTaskCode = 'AppsTaskCode';
    export const configKeyStatusAfterFixValueForQCFlag = 'StatusAfterFix_QC_Flag';
    export const configKeyCIDefaultText = 'CIDefaultText';
    export const configKeyUseCustomisedForms = 'UseCustomisedForms';
    export const configKeyUseNoCustomErrorCode = 'UseNoCustomErrorCode';
    export const configKeyUseAddNewMaterialReturn = 'UseAddNewMaterialReturn';
    export const configKeyMaxRecipientEntries = 'MaxRecipientEntries';
    export const configKeySelectDefaultFollowupReason = 'SelectDefaultFollowupReason';
    export const configKeyDisplayAdditionalMatReqInfo = 'DisplayAdditionalMatReqInfo';
    export const configKeyAddMaterialCurrencyCode = 'AddMaterialCurrencyCode';
    export const configKeyAddMaterialSelectBillableDefault = 'AddMaterialSelectBillableDefault';
    export const configKeyAddMaterialBillingIndicator = 'AddMaterialBillingIndicator';
    export const configKeyAddMaterialBillingChangeable = 'AddMaterialBillingChangeable';
    export const configKeyShowCommercialInfo = 'ShowCommercialInfo';
    export const configKeyCSMLTrackerLink = 'CSMLTrackerLink';
    export const configKeySeSoLink = 'SeSoLink';
    export const configKeyCBDocLink = 'CBDocLink';
    export const configKeySeSoDivisions = 'SeSoDivisions';
    export const configKeyAddDeliveryAddressTaxi = 'AddDeliveryAddressTaxi';
    export const configKeyDisablePaceForms = 'DisablePaceForms';
    export const configKeyDisplayTravelBackSummary = 'DisplayTravelBackSummary';
    export const configKeyDisplayAdditionalTravelInfo = 'DisplayAdditionalTravelInfo';
    export const configKeyDisplayMeansOfTransport = 'DisplayMeansOfTransport';
    export const configKeyDisplayAdditionalMatReturnInfo = 'DisplayAdditionalMatReturnInfo';
    export const configKeyFormatMultilineTextPattern = 'FormatMultilineTextPattern';
    export const configKeyFormatInternalInfoMultilineTextPattern = 'FormatInternInfoMultilinePattern';
    export const configKeyPaceFormsTypesForParticipantCopy = 'PaceFormsTypesForParticipantCopy';
    export const configKeyFormatMomentInUTC = 'FormatMomentInUTC';
    export const configKeyDisplayTimesheetAddress = 'DisplayTimesheetAddress';
    export const configKeyDisplayNonProductiveHours = 'DisplayNonProductiveHours';
    export const configKeyDisplayAdditionalTravelBack = 'DisplayAdditionalTravelBack';
    export const configKeyTravelBackStartEditable = 'TravelBackStartEditable';
    export const configKeyTravelBackEndEditable = 'TravelBackEndEditable';
    export const configKeyTimesheetEndTimeLimit = 'TimesheetEndTimeLimit';
    export const configKeyDisplayTimesheetAddressOptions = 'DisplayTimesheetAddressOptions';
    export const configKeyTimesheetAddressHome = 'TimesheetAddressHome';
    export const configKeyTimesheetAddressOffice = 'TimesheetAddressOffice';
    export const configKeyTimesheetPauseCodes = 'TimesheetPauseCodes';
    export const configKeyMatPrioritiesForDOP = 'MatPrioritiesForDOP';
    export const configKeyMatPrioritiesForCustomer = 'MatPrioritiesForCustomer';
    export const configKeyDisplayMaterialQuote = 'DisplayMaterialQuote';
    export const configKeyDisplayCustomerSignatureInForm = 'DisplayCustomerSignatureInForm';
    export const configKeySparePartsCatalogLink = 'SparePartsCatalogLink';
    export const showFleetLinkInEquipmentHistory = 'showFleetLinkInEquipmentHistory';
    export const configKeyDisableQuoteForNotificationTypes = 'DisableQuoteForNotificationTypes';
    export const configKeyEscalateNotificationTypes = 'EscalateNotificationTypes';
    export const configKeyDefaultReasonCodeForCentralScrap = 'DefaultReasonCodeForCentralScrap';
    export const configKeyDisableSpecialTransportAWBfield = 'DisableSpecialTransportAWBfield';
    export const configKeyDangerousGoodsInd = 'DangerousGoodsInd';
    export const configKeyBootstockReplenishEnabled = 'BootstockReplenishEnabled';
    export const configKeySpecialDangerousGoodsInd = 'SpecialDangerousGoodsInd';
    export const configKeyTextClausePattern = 'TextClausePattern';
    export const configKeyShowMobileNumberForParticipants = 'ShowMobileNumberForParticipants';
    export const configKeyShowCalibrationDate = 'ShowCalibrationDate';
    export const configKeyShowCustomerInformationOnSummary = 'ShowCustomerInformationOnSummary';
    export const configKeyUseCustomTimeInput = 'UseCustomTimeInput';
    export const configKeyFormatMultilineTextOnBlur = 'FormatMultilineTextOnBlur';
    export const configKeyShowFormCustomerEmailData = 'ShowFormCustomerEmailData';
    export const configKeyUseCustomDurationStepper = 'UseCustomDurationStepper';
    export const configKeyPrefillTroubleText = 'PrefillTroubleText';
    export const configKeyEnableJobOnFly = 'EnableJobOnFly';
    export const configKeyJobOnFlyDefaultDuration = 'JobOnFlyDefaultDuration';
    export const configKeyActivateCosima = 'ActivateCosima';
    export const configKeyDisplayMaterialPricing = 'DisplayMaterialPricing';
    export const configKeyDisplayCustomerPrice = 'DisplayCustomerPrice';
    export const configKeyDisplayCentralScrap = 'DisplayCentralScrap';
    export const configKeyDisplayCentralScrapDangerGoods = 'DisplayCentralScrapDangerGoods';
    export const configKeyDisplayBatchNumber = 'DisplayBatchNumber';
    export const configKeyDisplayWeeklyWorkTime = 'DisplayWeeklyWorkTime';
    export const configKeyEnableStandbyTravel = 'EnableStandbyTravel';
    export const configKeyIsTravelBillable = 'IsTravelBillable';
    export const configKeySmartSensorTracker = 'SmartSensorTracker';
    export const configKeySmartSensorTrackerUrl = 'SmartSensorTrackerUrl';
    export const configKeyMatSerTypeaheadToggle = 'MatSerTypeaheadToggle';
    export const configKeyMatLTextDisplayLines = 'MatLTextDisplayLines';
    export const configKeyDisplayAdditionalTravelCost = 'DisplayAdditionalTravelCost';
    export const configKeyAdditionalTravelCostText = 'AdditionalTravelCostText';
    export const configKeyMaxWeeklyWorkingHours = 'MaxWeeklyWorkingHours';
    export const configKeyDisplayCseSignature = 'DisplayCseSignature';
    export const configKeyDisplayBootStockIndicator = 'DisplayBootStockIndicator';
    export const configKeyBootStockScrapEnabled = 'BootstockScrapEnabled';
    export const configKeyAllowNotificationPause = 'AllowNotificationPause';
    export const configKeyEnableAfterHourCallOut = 'EnableAfterHourCallOut';
    export const configKeyShowMeasurementToolsDetails = 'ShowMeasurementToolsDetails';
    export const configKeyDisplayTrendCodeInFollowup = 'DisplayTrendCodeInFollowup';
    export const configHideParticipantFormSubmission = 'HideParticipantFormSubmission';
    export const configKeyShowDataMediumInEquipment = 'ShowDataMediumInEquipment';
    export const configKeyAnaLink = 'AnaLink';
    export const configKeyShowIconForMaterialDelivery = 'ShowIconForMaterialDelivery';
    export const configKeyTeamplayFleetLink = 'TeamplayFleetLink';
    export const configKeyShowTpfReportVisibility = 'ShowTpfReportVisibility';
    export const configKeyMandatoryTpfReportVisibility = 'MandatoryTpfReportVisibility';
    export const configKeyDefaultTpfReportVisibility = 'DefaultTpfReportVisibility';
    export const configKeyComplaintsQuestionnaireLink = 'ComplaintsQuestionnaireLink';
    export const configKeySparePartCatalogMatLink = 'SparePartCatalogMatLink';
    export const configKeyEnableTimesheetEmail = 'EnableTimesheetEmail';
    export const configKeyShowUploadToDocBoxForNotificationType = 'ShowUploadToDocBoxForNotifType';
    export const configKeyUploadToDocBoxMandatoryForNotificationType = 'MandUploadToDocBoxForNotifType';
    export const configKeyUploadToDocBoxStatusMandatory = 'UploadToDocBoxStatusMandatory';
    export const configKeyUploadToDocBoxAllowedMimeTypes = 'UploadToDocBoxAllowedMimeTypes';
    export const configKeyDocBoxInstallationType = 'DocboxDoctype_Installation';
    export const configKeyDocBoxEnableReportTypeSelection = 'DocboxEnableReportTypeSelection';
    export const configKeyDisableTimesheet = 'DisableTimesheet';
    export const configKeyDataManagementEmail = 'DataManagementEmail';
    export const configKeyDataManagementEmailInvitro = 'DataManagementEmailInvitro';
    export const configKeyShowStartImmediately = 'ShowStartImmediately';
    export const configKeyShowPlaceHolderForReportText = 'ShowPlaceHolderForReportText';
    export const configKeyShowPlaceHolderForEscalationText = 'ShowPlaceHolderForEscalationText';
    export const configKeyMaxWorkingHoursInTimesheet = 'MaxWorkingHoursInTimesheet';
    export const configKeyHideComplaintsForUserStatusType = 'HideComplaintsForUserStatusType';
    export const configKeyBackendName = 'BackendName';
    export const configKeyDisplayConfirmSignatures = 'DisplayConfirmSignatures';
    export const configKeyEnableRemoteWork = 'EnableRemoteWork';
    export const configKeyShowRemoteStatusChangeWarning = 'ShowRemoteStatusChangeWarning';
    export const configKeyDisplayDocBox = 'DisplayDocBox';
    export const configKeyEnableHideTimesheetAddress = 'EnableHideTimesheetAddress';
    export const configKeyHideTimesheetPersonnelSubArea = 'HideTimesheetPersonnelSubarea';
    export const configKeyMatQuoteDistanceUnit = 'MatQuoteDistanceUnit';
    export const configKeyEnableMatQuoteDistance = 'EnableMatQuoteDistance';
    export const configKeyEquipmentErrorCodeRemoteWork = 'EquipmentErrorCodeRemoteWork';
    export const configKeyDisplayConfirmationDistance = 'DisplayConfirmationDistance';
    export const configKeyDisplayConfirmationExpenses = 'DisplayConfirmationExpenses';
    export const configKeyDowntimeThresholdInMinutes = 'DowntimeThresholdInMinutes';
    export const configKeyEnableIndividualDocBoxDownload = 'EnableIndividualDocBoxDownload';
    export const configKeyShowDataMaintenanceEnhancement = 'ShowDataMaintainanceEnhancement';
    export const configKeyDisplayServicePartQuestionnaire = 'DisplayServicePartQuestionnaire';
    export const configKeyMaterialOrderTextInfoLineLength = 'MaterialOrderTextInfoLineLength';
    export const configKeyMaterialOrderTextInfoMaxLines = 'MaterialOrderTextInfoMaxLines';
    export const configKeyMaterialOrderTextInfoPattern = 'MaterialOrderTextInfoPattern';
    export const configKeyCSMLInvivoPhoneNumber = 'CSMLInvivoPhoneNumber';
    export const configKeyCSMLInvitroPhoneNumber = 'CSMLInvitroPhoneNumber';
    export const configKeyEnableTextInfoValidation = 'EnableTextInfoValidation';
    export const configKeyByBoxKonnectLink = 'ByBoxKonnectLink';
    export const configKeyMeasurementToolsDefaultSettingsAPPS = 'MeasToolsDefaultSettingsAPPS';
    export const configKeyHideRecoveryTimeForNotificationTypes = 'HideRecoveryTimeForNotifTypes';
    export const configKeyShowFCCForNotificationTypes = 'ShowFCCForNotificationTypes';
    export const configKeyReportAnIssueAllowedMimeTypes = 'ReportAnIssueAllowedMimeTypes';
    export const configKeyShowCyberSecurityQuestion = 'ShowCyberSecurityQuestion';
    export const configKeyCommercialInfMandatoryForNonBill = 'CommercialInfMandatoryForNonBill';
    export const configKeyEnableOtherTasks = 'EnableOtherTasks';
    export const configKeyGetOtherTasksOverlapUpcomingNotification = 'GetOtherTasksOverlapUpcomingNoti';
    export const configKeyDeliveryOptionsEnabled = 'DeliveryOptionsEnabled';
    export const configKeyDeliveryApprovalMinimumLength = 'DeliveryApprovalMinimumLength';
    export const configKeyDisplaySideMenuDocBoxFlag = 'DisplaySideMenuDocbox';
    export const configKeySafetyAssessmentForm = 'SafetyAssessmentForm';
    export const configKeyEnableSafetyAssessmentForm = 'EnableSafetyAssessmentForm';
    export const configKeyEnablePaceFormsCrossDeviceSync = 'EnablePaceFormsCrossDeviceSync';
    export const configKeyEnableDurationChange = 'AllowDurationChange';
    export const configKeyAppBookingForPartners = 'AppBookingForPartners';
    export const configKeyAppBookingEnabled = 'AppBookingEnabled';
    export const configKeyAppBookingMinDate = 'AppBookingMinDate';
    export const configKeyAppBookingMaxDate = 'AppBookingMaxDate';
    export const configKeyAppBookingMaxDuration = 'AppBookingMaxDuration';
    export const configKeyAppBookingShowDedicated = 'AppBookingShowDedicated';
    export const configKeyAppBookingDefaultDedicated = 'AppBookingDefaultDedicated';
    export const configKeyAppBookingITCS = 'AppBookingITCS';

    export const configKeyCustomerDamageEnabled = 'EnableCustomerDamage';
    export const configKeyFocReplacementEnabled = 'EnableFocReplacement';
    export const configKeyParticipantCreditTypeSelectorEnabled = 'EnableParticipantCreditTypeSel';
    export const configKeyDeliveryCutoffTimeEnabled = 'EnableDeliveryCutoffTime';
    export const configKeyEnableSourceReplacement = 'EnableSourceReplacement';
    export const configKeyMaterialPickupRFIDEnabled = 'PickupRFIDEnabled';
    export const configKeyAWBPackagingEnabled = 'AWBPackagingEnabled';
    export const configKeyEnableFedexAwbPackaging = 'EnableFedexAwbPackaging';
    export const configKeyInstallationPaperworkEnabled = 'InstallationPaperworkEnabled';
    export const configKeyEarlyTravelHours = 'EarlyTravelHours';
    export const configKeyRentalToolAllowWithNoConsumption = 'RentalToolAllowWithNoConsumption';
    export const configKeyBootstockReturnEnabled = 'BootstockReturnEnabled';
    export const configKeyEnableForceCheckin = 'EnableForceCheckIn';
    export const configKeyEnableMeasurementToolsForSCRM = 'EnableMeasurementToolsForSCRM';
    export const configKeyShowRemoteWork = 'ShowRemoteWork';
    export const configKeyShowStartImmediatelyFollowUp = 'ShowStartImmediateFolUp';

    export const valueHelperIdCustomerDamageCodes = 'CustomerDamageCodes';
    export const valueHelperIdFocAdditionalLaborCodes = 'FocAdditionalLaborCodes';
    export const valueHelperIdFocAdditionalMaterialCodes = 'FocAdditionalMaterialCodes';

    // TODO: these values should not be hard coded. What if lookup tables change in backend?
    export enum BILLABLE_CODE {
        AUTO = '',
        BILLABLE = 'B',
        NON_BILLABLE = 'N',
        COURTESY = 'C',
        CUSTOMER_DAMAGE = 'D',
    }

    export enum SYNCING_STATUS {
        IDLE = 'idle',
        LOADING = 'loading',
        SUCCESS = 'success',
        ERROR = 'error',
    }

    export const totalWorkingHours = 10;
    export const nineHoursWorkDuration = 9;

    export const maxRecipientEntries = 10;

    export const returnCustomer = 'Customer';
    export const returnDop = 'DOP';
    export const returnFedex = 'FedEx';
    export const returnTaxi = 'Taxi';
    export const returnNotSelected = 'NA';
    export const bootStockScrapCode = 'L';

    // constants for corporate Information
    export const configKeyCorpInfoHQ1 = 'CorpInfoHQ1';
    export const configKeyCorpInfoHQ2 = 'CorpInfoHQ2';
    export const configKeyCorpInfoHQ3 = 'CorpInfoHQ3';
    export const configKeyCorpInfoHQ4 = 'CorpInfoHQ4';
    export const configKeyCorpInfoHQ5 = 'CorpInfoHQ5';
    export const configKeyCorpInfoHQ5Link = 'CorpInfoHQ5Link';
    export const configKeyCorpInfoHQTel = 'CorpInfoHQPhone';

    export const configKeyCorpInfoLegalInfo1 = 'CorpInfoLegalInfo1';
    export const configKeyCorpInfoLegalInfo2 = 'CorpInfoLegalInfo2';
    export const configKeyCorpInfoLegalInfo3 = 'CorpInfoLegalInfo3';
    export const configKeyCorpInfoLegalInfo4 = 'CorpInfoLegalInfo4';
    export const configKeyCorpInfoLegalInfo5 = 'CorpInfoLegalInfo5';
    export const configKeyCorpInfoLegalInfo6 = 'CorpInfoLegalInfo6';
    export const configKeyCorpInfoLegalInfo7 = 'CorpInfoLegalInfo7';

    export const configKeyCorpInfoLegalInfoPolicy = 'CorpInfoLegalInfoPolicy';
    export const configKeyCorpInfoLegalInfoPolicyLink = 'CorpInfoLegalInfoPolicyLink';
    export const configKeyCorpInfoLegalInfoTOU = 'CorpInfoLegalInfoTOU';
    export const configKeyCorpInfoLegalInfoTOULink = 'CorpInfoLegalInfoTOULink';
    export const configKeyCorpInfoLegalPolicyMonth = 'CorpInfoLegalPolicyMonth';

    export const configKeyCorpInfoSupportHours = 'CorpInfoSupportHours';
    export const configKeyCorpInfoSupportLink = 'CorpInfoSupportLink';
    export const configKeyCorpInfoSupportEmail = 'CorpInfoSupportEmail';
    export const configKeyCorpInfoSupportCreateTicketLink = 'CorpInfoSupportCreateTicketLink';

    // constants for storage location
    export const configKeyGlobalStorageLocation = 'GlobalStorageLocation';
    export const configKeyGlobalStorageLocationMatPricing = 'GlobalStorageLocationMatPricing';
    export const configKeyGlobalStorageLocationMatRequest = 'GlobalStorageLocationMatRequest';

    export const configKeyPreviousDaysTimesheetLimit = 'PreviousDaysTimesheetLimit';
    export const configKeyMaxAllowedFutureTime = 'MaxAllowedFutureTime';
    export const configKeyDivisionsWithAdditionalLegalText = 'DivisionsWithAdditionalLegalText';
    export const configKeyDivisionsWithIEC62353 = 'DivisionsWithIEC62353';
    export const configKeyDivisionsWithVDE701702 = 'DivisionsWithVDE701702';
    export const configKeyDivisionsWithVerifLegalCheck = 'DivisionsWithVerifLegalCheck';
    export const configKeyEmojisRegex = 'EmojisRegex';
    export const configKeyEnableMatReturnWorkAround = 'EnableMatReturnWorkAround';
    export const configKeyDisplayAddMaterialButton = 'DisplayAddMaterialButton';
    export const configKeyEnableBillingIndicator = 'EnableBillingIndicator';
    export const configKeyBKInfoTextForBillingIndicatorsNotReceived = 'BKInfoTextForBillingIndicatorsX';
    export const configKeyMaterialOrderDeliveryOptions = 'MaterialOrderDeliveryOptions';
    export const configKeyMaterialReturnAddressOptions = 'MaterialReturnAddressOptions';
    export const configKeyEnableTextInfoForDop = 'EnableTextInfoForDop';
    export const configKeyShowBootOtherStockWarning = 'ShowBootOtherStockWarning';
    export const configKeyEnableStatesOfUSADropdown = 'EnableStatesOfUSADropdown';
    export const configKeyDocMissingProtocolsEnabled = 'DocMissingProtocolsEnabled';
    export const configKeyEnableFDA2579Form = 'EnableFDA2579Form';
    export const configKeyCentricarePCHEnabled = 'CentricarePCHEnabled';
    export const configKeyCentricarePCHWarningTime = 'CentricarePCHWarningTime';
    export const configKeyRadioactiveSurveyEnabled = 'RadioactiveSurveyEnabled';
    export const configKeyRadioactiveSurveyDivisions = 'RadioactiveSurveyDivisions';
    export const configKeyRadioactiveSurveyToolCalibration = 'RadioactiveSurveyToolCalibration';
    export const configKeyRadioactiveSurveyRegions = 'RadioactiveSurveyRegions';
    export const configKeyEnableCommercialInfoMandatory = 'EnableCommercialInfoMandatory';
    export const configKeyPhysicalInventoryEnabled = 'PhysicalInventoryEnabled';
    export const configKeyEnableUnlimitedHandOver = 'EnableUnlimitedHandOver';
    export const configKeySmartlockerEnabled = 'EnableSmartLocker';
    export const configKeySmartlockerIdentifier = 'SmartlockerMaterialIdentifier';
    export const configKeyDateTimeFormatPattern = 'DateTimeFormatPattern';
    export const configKeyUseCsmlUrlWithParam = 'UseCsmlUrlWithParam';

    export const configKeyMatRequestSubAddressCharLimit = 'MatRequestSubAddressCharLimit';
    export const configKeyMatRequestContactCharLimit = 'MatRequestContactCharLimit';
    export const subAddressMaxCharLimit = 28;
    export const contactMaxCharLimit = 29;
    export const defaultSmartlockerIdentifier = '\\SL(\\d{5})';

    // Constant used to filter the material based on the storageLocation key
    export const materialFilterKey = 'StorageLoc';

    export const stringSeparator = '|';

    export const ngmP58App = 'Ngm58';
    export const ngmAaApp = 'NgmAA';

    export enum AttendanceType {
        WORK = 'WORK',
        FREE = 'FREE',
    }

    export enum ParticipantCreditType {
        NON_CREDIT = '0',
        CREDIT = '1',
        NOT_AVAILABLE = '2',
    }

    export enum ParticipantCreditTypeOptions {
        NON_CREDIT = 'Non-credit',
        CREDIT = 'Credit',
        NOT_AVAILABLE = 'N/A',
    }

    export enum DeliveryReturnOptions {
        Customer = 'Customer',
        Dop = 'DOP',
        Fedex = 'FedEx',
        Taxi = 'Taxi',
        NotSelected = 'NA',
    }

    export enum PI_ALERT_TYPE {
        OFFLINE_ALERT = 'isOfflineAlertConfirmed',
        SCHEDULE_ALERT = 'isScheduleAlertConfirmed',
        RESCHEDULE_ALERT = 'isRescheduleAlertConfirmed',
        NEW_ALERT = 'isNewScheduleAlertConfirmed',
    }

    export enum EVENT_TYPE {
        Sync,
        Offline,
        UserClick,
    }

    export const enLocale = 'en';
    export const localeNumberFormat = '0.0-0';

    // Constants specific to NgmAA
    export const maxRecipientEntriesAA = 4;
    export const maxMaterialOrderItems = 40;

    // Use in NGMAA to tell apart the CSE storage locations
    export const dopNewPartsIndicator = '1';
    export const dopDefectPartsIndicator = '3';

    // Use in NGMAA for different values of Material Billing Indicator
    export const materialBillableIndicator = 'Y';
    export const materialNonBillableIndicator = 'N';

    export const materialRepairableIndicator = 'J';

    export const materialQualityPartIndicator = 'J';

    // Use in NGMAA for measuring points value in case not available(instead of sending blank)
    export const measuringPointValueNotAvailable = 'NV';

    // The maximum amount of years used throughout the system. Default is everywhere 1000
    export const maxAmountOfYears = 1000;

    // The value needed to transform seconds to minutes, and minutes to hours
    export const timeMultiplier = 60;

    // The value needed to transform milliseconds in seconds
    export const milliSecToSecConversionFactor = 1000;

    export const oneHourInMilliSec =
        ConfigConstants.timeMultiplier * ConfigConstants.timeMultiplier * ConfigConstants.milliSecToSecConversionFactor;

    // Default duration in hours for Job on Fly in case it is not maintained in gateway
    export const jobOnFlyDefaultDuration = 1;

    // Constants specific to Material stock
    export const BOOT_STOCK_SCREEN = 'CseBootStock';
    export const OTHER_STOCK_SCREEN = 'CseOtherStock';

    // Currently Siemens has 2 separate business processes defined: InVivo and InVitro
    export enum PROCESS_INDICATOR {
        INVIVO = '',
        INVITRO = 'X',
        UNKNOWN = '?',
    }

    // supported locale id code
    export enum LOCALE_CODES {
        US = 'EN-US',
        JA = 'JA',
        JP = 'JA-JP',
        IN = 'EN-IN',
        AU = 'EN-AU',
        NZ = 'EN-NZ',
        DE = 'DE-DE',
        CN = 'ZH-CN',
    }

    // supported locale currency code
    export enum CURRENCY_CODES {
        EUR = 'EUR',
        AUD = 'AUD',
        INR = 'INR',
        JPY = 'JPY',
        NZD = 'NZD',
        CNY = 'CNY',
        USD = 'USD',
    }

    // activity type for Time confirmation always 'A' for PACE US
    export const timeRecordingActivityType = 'A';

    // Use in PACE US to identify the "Other" and "Technologist" Entries from the title dropdown for the attendee component
    export const attendeeTitleOther = 'Other';
    export const attendeeTitleTechnologist = 'Technologist';

    export const defaultLineLength = 120;
    export const nonSiemensPartMaterialTypeCode = 'NSP';
    export const siemensPartMaterialTypeCode = 'SP';

    export const defaultCustomerApproverLength = 5;

    export enum SHIPPING_PRIORITY {
        DEFAULT = 'D',
        ALTERNATIVE = 'A',
        PAYABLE = 'P',
    }

    /**
     * String-based enum for easier access in markup (readability!)
     */
    export enum SYNC_STATE {
        OFFLINE = 'offline',
        ONLINE = 'online',
        SYNCING = 'syncing',
        PENDING = 'pending',
    }

    // Constant specific to form validation status defined by angular
    // Other statuses that might be added in the future are 'INVALID', 'PENDING' and 'DISABLED'
    export const formValid = 'VALID';
    export const formInvalid = 'INVALID';

    // Units for Input field
    export enum INPUT_FIELD_UNITS {
        mOhm = 'mOhm',
        mA = 'mA',
        MOhm = 'MOhm',
    }

    // Equipment statuses
    export enum EQUIPMENT_STATUS {
        TOTALLY_DOWN = '1',
        PARTIALLY_DOWN = '2',
        WORKING = '3',
        APP_WORKING = '6',
        APP_PARTIALLY_DOWN = '7',
        APP_DOWN = '8',
        PARTIALLY_DOWN_CRITICAL = 'A',
        PARTIALLY_DOWN_NORMAL = 'B',
    }

    // Follow up short text content
    export enum FOLLOWUP_SHORT_TEXT {
        FOLLOWUP = 'Follow Up',
        MATERIAL = ' MAT',
        EQUIPMENT = ' SYST',
        ADD_INFO = ' INT',
        INSTALLATION_PAPERWORK = 'INPW',
    }

    // Flag to determine follow up visit request
    // 2 stands for remote work in SAP, while 0 stands for no follow-up. There is no separate flag for remote work in SAP, so we need to overwrite the follow-up flag with 2 in case of remote work
    export enum FOLLOWUP_VISIT_FLAG {
        NO_FOLLOWUP = '0',
        FOLLOWUP = '1',
        FOLLOWUP_REMOTE_WORK = '2',
    }

    export enum STATUSBAR_TYPE {
        SUCCESS = 'success',
        INFO = 'info',
        WARNING = 'warning',
        DEFAULT = 'default',
        CUSTOM = 'custom',
    }

    export enum INFO_TEXTID {
        FUNCTION = 'ZC01',
        CONTACT_NAME = 'ZC02',
        TELEPHONE = 'ZC03',
        MOBILE = 'ZC04',
        EMAIL = 'ZC05',
        DEPARTMENT = 'ZC06',
        NOTES = 'ZC07',
        PARKING = 'ZI01',
        TECHNICAL_SPEC = 'ZI02',
        ORG_MATTER = 'ZI03',
        CONSTANCY = 'ZI04',
        DISPATCH = 'ZI05',
        SUBSYSTEM = 'ZI06',
    }

    export enum FORM_STATUS {
        VALID = 'VALID',
        INVALID = 'INVALID',
    }

    export enum INTERNAL_INFO_CATEGORY {
        CONTACT = 'Contacts',
        PARKING = 'Parking',
        TECHNICAL_SPEC = 'Technical specifics',
        ORG_MATTERS = 'Organizational matters',
        CONSTANCY_CHECK = 'Constancy check',
        DISPATCH = 'Dispatch',
        SUB_SYSTEMS = 'Sub systems',
    }

    export enum SOURCE_REPLACEMENT_INDICATOR {
        NO_CHANGE = 'N',
        UPDATED = 'U',
        DELETED = 'D',
        ADDED = 'A',
    }

    export const SOURCE_REPLACEMENT_MAX_ENTRIES = 10;
    export const SOURCE_REPLACEMENT_TEXT_SPLITTER = ';';

    export const connectionTypeNone = 'none';

    export const iosLogFile = 'Logs/HIT_CESWrapperLogFile.log';
    export const appserviceLogFile = 'appservice.log.txt';
    export const commandQueueFile = 'CommandQueue.txt';
    export const windowsLogFile = 'console.log';

    export const FILE_EXTENSION_HEADERS = {
        bmp: 'image/bmp',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        gif: 'image/gif',
        htm: 'text/html',
        html: 'text/html',
        jpeg: 'image/jpeg',
        jpg: 'image/jpeg',
        json: 'application/json',
        png: 'image/png',
        pdf: 'application/pdf',
        ppt: 'application/vnd.ms-powerpoint',
        pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        rtf: 'application/rtf',
        ttf: 'font/ttf',
        txt: 'text/plain',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        xml: 'application/xml&nbsp;',
    };

    export const enum TravelStatusErrors {
        INVALID_START_OF_WORK_ERROR = 'Selected date and time is before the previous end of work',
        TIMESHEET_PENDING_ERROR = 'Status update not possible because of pending timesheet',
        TIMESHEET_OVERLAP_ERROR = 'Timesheet overlaps, Status update not possible',
        TIMESHEET_OVERLAP_ADAPT_LAST_TRBK_TIME = 'Adapting last travel back time',
        START_OF_WORK_BREAK_WARNING = 'Less than 11h break between EoW and SoW',
    }

    export const inputTypeText = 'text';
    export const inputTypeNumeric = 'numeric';

    export const jsonContent = 'application/json';
    export const assayIndicator = 'AS'; // as defined in interface specification
    export const CodeGroupForInitialHandoverTraining = 'IHOT';
    export const CodeGroupForDeInstallation = 'DINT';
    export const CodeGroupForSystemInstallation = 'SINT';
    export const CodeGroupForSystemMove = 'SYSM';
    export const CodeGroupForReInstallation = 'RINT';
    export const CodeTypeForActivity = 'A';

    // Medical physics evaluation ("Texas EPE") question in the follow-up section
    export const medPhysicsUSStates = ['MN', 'TX'];
    export const medPhysicsInstallationCodeGroups = [
        CodeGroupForSystemInstallation,
        CodeGroupForSystemMove,
        CodeGroupForReInstallation,
    ];
    export enum TEXAS_EPE_CODE {
        YES = 'US03',
        NO = 'US04',
    }

    export enum SWIPE_ACTION {
        LEFT = 'swipeleft',
        RIGHT = 'swiperight',
        UNKNOWN = 'noswipe',
    }

    export const userCountryFI = 'UserCountryFI';
    export const disclaimerForChinaFI = 'UserCountryFIDisc';

    export const configKeyHideAbortAllFormsButton = 'HideAbortAllFormsButton';
    export const configKeyEnableAbortFormInList = 'EnableAbortFormInList';

    export const configKeyPlaceHolderForCustomerIdentification = 'PlaceHolderCustomerIdent';

    export const configKeyEnableManIndividualization = 'EnableManIndividualization';

    export const configKeyEnableHistoricalValues = 'EnableHistoricalValues';

    export const FileUploadSizeAllowed = 10 * 1024 * 1024;

    export const configKeyHideSubmitButtonForForms = 'HideSubmitButtonForForms';

    export const configKeyHideAuthorsFormsButtons = 'HideAuthorsFormsButtons';

    export const configKeyCriticalityNotifTypes = 'CriticalityNotifTypes';

    // Defines possible Push Notification states
    export enum PushNotificationsPermissionState {
        Granted = 'granted',
        Denied = 'denied',
        Default = 'default',
    }

    export const appStartedFromPushNotificationLocalStorageItem = 'appStartedFromPushNotification';

    export const configKeyEnableDocumentFeedbackButton = 'EnableDocumentFeedbackButton';

    export enum SectionTitle {
        MISCELLANEOUS = 'Miscellaneous',
    }

    export enum EntryTitle {
        DOCBOX = 'DocBox',
    }

    export const DOCBOX_URL = 'docbox';
    export const SLOC = 'SLOC';
    export const DeliveryCutOffTimeNotAvailable = 'N/A';

    export enum ApprovedPCHCodes {
        CODE_GROUP = 'YCCU',
        CODE_NAME = 'PCHW',
    }

    export enum ODataPCHDurationTypeEnum {
        PCHW = 'PCHW',
        APPR = 'APPR',
    }

    export const initialCentricarePCHWarningTime = 15; // in minutes
    export const configKeyInstallationPaperworkFlag = 'DisplayInstallationPaperwork';

    // CONFIRMATION INSTALLATION PAPERWORK
    export enum INSTALLATION_PAPERWORK_CODES {
        startupStatus = 'STST',
        siemensPunchList = 'STPL',
        customerPunchList = 'STPC',
        isPersionLeadResponsible = 'PINS',
        isSystemReadyForStartupAndDayOne = 'IN01',
        isIVKVerified = 'IN02',
        differentSerialNumberThanIVKLongText = 'IN03',
        isSRSVerifiedBySrsTse = 'IN04',
        isDICOMProvided = 'IN05',
        isSafetyUICompleted = 'IN06',
        finalDayAttachments = 'IN07',
        cseHandoverMethod = 'IN08',
        cseHandoverName = 'IN09',
        cseHandoverDate = 'IN10',
        isArtisLicenseKeyRemoved = 'IN11',
        isIVKsubmittedForSyngo = 'IN12',
        isLeonardoLicenseKeyRemoved = 'IN13',
        isSiemensSoldOEMEquipment = 'IN14',
        isPaceStartupAttached = 'IN15',
        attachIQAPReport = 'IN16',
        attachFDA2579Form = 'IN17',
        isIseCseMetricFormComplete = 'IN18',
        heliumLevelArrival = 'IN19',
        isChillerFlModelSerialGiven = 'IN20',
        heliumLevelCompletion = 'IN21',
        magneticCurrent = 'IN22',
        isMagnetRampedDownAtRequest = 'IN23',
        isHeliumTrackerDataEntered = 'IN24',
        syngoClassicOrNativeSoftware = 'IN25',
        attachSyngoSafetyRelatedReport = 'IN26',
        preRampPhotos = 'IN27',
        isMRDoorSwitchOperational = 'IN28',
        startupReportMR = 'IN30',
        installationReport = 'IN31',
        siteType = 'IN32',
    }

    export enum INSTALLATION_PAPERWORK_SYSTEM_STARTUP_STATUS {
        startupInProgress = '1', // 'SYSTEM STARTUP IN PROGRESS',
        startupComplete = '2', // 'SYSTEM STARTUP COMPLETE',
        startupCompleteOpenPunchlists = '3', // 'SYSTEM STARTUP COMPLETE - OPEN PUNCHLIST',
    }

    export enum INSTALLATION_PAPERWORK_SYSTEM_STARTUP_STATUS_GW_VALUE_RESPONSE {
        startupInProgress = 'SYSTEM STARTUP IN PROGRESS',
        startupComplete = 'SYSTEM STARTUP COMPLETE',
        startupCompleteOpenPunchlists = 'SYSTEM STARTUP COMPLETE-OPEN P',
    }

    export enum INSTALLATION_PAPERWORK_HANDOVER_METHOD {
        phone = '2_PHONE',
        onsite = '1_ONSITE',
        voicemail = '3_VOICEMAIL',
        text = '4_TEXT',
    }

    export const INSTALLATION_PAPERWORK_HANDOVER_ASSOCIATION = ['Mobile', 'Cassling', 'Delta', 'Medlab', 'DISS'];

    export enum INSTALLATION_PAPERWORK_SYNGO_SOFTWARE {
        classic = '1_CLASSIC',
        native = '2_NATIVE',
    }

    export enum INSTALLATION_PAPERWORK_SITE_TYPE {
        newConstruction = '1_NEWCONSTRUCTION',
        existing = '2_EXISTING',
    }

    export const OPTION_1_YES = '1_YES';
    export const OPTION_0_NO = '0_NO';
    export const OPTION_2_NA = '2_NA';
    export const OPTION_0_NA = '0_NA';

    export const INSTALLATION_PAPERWORK_OPTIONS: Record<string, string> = {};
    INSTALLATION_PAPERWORK_OPTIONS[optionYes] = OPTION_1_YES;
    INSTALLATION_PAPERWORK_OPTIONS[optionNo] = OPTION_0_NO;
    INSTALLATION_PAPERWORK_OPTIONS[optionNA] = OPTION_2_NA;
    INSTALLATION_PAPERWORK_OPTIONS[OPTION_1_YES] = optionYes;
    INSTALLATION_PAPERWORK_OPTIONS[OPTION_0_NO] = optionNo;
    INSTALLATION_PAPERWORK_OPTIONS[OPTION_2_NA] = optionNA;

    export const INSTALLATION_PAPERWORK_OPTIONS_YES_NA: Record<string, string> = {};
    INSTALLATION_PAPERWORK_OPTIONS_YES_NA[optionYes] = OPTION_1_YES;
    INSTALLATION_PAPERWORK_OPTIONS_YES_NA[OPTION_1_YES] = optionYes;
    INSTALLATION_PAPERWORK_OPTIONS_YES_NA[optionNA] = OPTION_0_NA;
    INSTALLATION_PAPERWORK_OPTIONS_YES_NA[OPTION_0_NA] = optionNA;

    export const INSTALLATION_PAPERSET_CODE_TYPE = 'A';
    export const INSTALLATION_PAPERSET_CODE_GROUP = 'INPW';
    export const INSTALLATION_PAPERSET_PUNCHLIST_COMPLETE = 'Fixed';

    export enum INSTALLATION_PAPERWORK_FOLLOWUP_SHORT_TEXT {
        FOLLOW_UP_IN_PROGRESS = 'Follow-up:Install In-progress',
        FOLLOW_UP_PAPERWORK_INCOMPLETE = 'Follow-up: Install Paperwork Incomplete',
        FOLLOW_UP_PUNCHLIST = 'Follow-up: Punchlist',
        FOLLOW_UP_EMPTY = '',
    }

    export const installationPaperworkCrmHeader = 'PaperSet';
    export const configKeyIseCseMetricFormAppLink = 'IseCseMetricFormAppLink';

    export enum MAT_INDICATOR {
        RETURN = 'R',
        DELETE = 'D',
        BOOTSTOCK_RETURN = 'T',
        BOOTSTOCK_SCRAP = 'U',
    }

    export const DOCUMENT_STATUS_FINAL = 'F';
}
